import { Component, ElementRef,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from 'src/app/services/pageviewsettings.service';

import { forkJoin } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import * as Globals from '../../globals';

declare let analytics: any;
interface PageSettings {
  backgroundimage: string;
  choosesectionbgcolor: string;
  fontsize: string;
  title: string;
  subtitle: string;
  // plans: Plan[];
  whyHusky: { title: string; description: string }[];
}

interface broadbandPlan {
  planName: string;
  provider: string;
  disclosure: string;
  monthlyPrice: string;
  monthlyPriceNote: string;
    additionalFees: {
    label: string;
    amount: string;
  }[]
;
  governmentTaxes: string;
  speeds:  {
  download: string;
  upload: string;
  latency: string;
};
  dataIncluded: string;
  networkPolicyUrl: string;
  privacyPolicyUrl:string;
  support:  {
  phone: string;
  website: string;
}
  code: string;
}

interface CardDetail {
  text: string;
}


type planData = '5GB' | '10GB' | '15GB' | '30GB';

@Component({
  selector: 'app-faculty-plans',
  templateUrl: './faculty-plans.component.html',
  styleUrls: ['./faculty-plans.component.css']
})

export class FacultyPlansComponent {
  pageSettings: any = {};
 	logoPrimaryImageUrl = '';
	logoSecondaryImageUrl = '';
  bannerimageurl = '';
  showCards = false;
  tenantId:any;
  affiliateId:any;
  colors: { name: string; color: string }[] = [
    { name: "huskymobile", color: "#4b2e83" },
    { name: "osumobile", color: "#550000" },
    { name: "calmobile", color: "#00008b" },
    { name: "hushymobile", color: "#06402b" },
  ];

    plans: {
  id: number;
  url:string;
  data:string;
  name: string;
  price: number;
  discountedPrice: number;
  description: string;
  subText: string;
  features: { title: string; description?: string }[]; // optional description
  highlight: boolean;
}[] = []
  plansdata:any
  plansarray:any[]=[]
  images = {
    background: '',
    banner: '',
    
  };
  plansdata2: any;
  broadbandLabelData: any[]=[];
  selectedPlanName: any;
  broadbanddata: any[]=[];

   ;
  defaultImages = {
    background: '/api/assets/affiliate/1/tenant/1/images/landing-bg.jpg',
    banner: 'assets/landingpageplaceholderimage.png',
     logo: 'assets/schooldarklogo.png'
  };

  getPlanUrl (planId: number) {
    switch (this.tenantId ) {
      case 1: 
        switch (planId) {
          case 4 : return 'https://husky-faculty.app.collegiatemobile.com/prepaid?planOfferingId=poff_L5F05LF1B0AH41DB'
          case 5 : return 'https://husky-faculty.app.collegiatemobile.com/prepaid?planOfferingId=poff_DZBUHFVOMWU2VRFA';
          case 6 : return 'https://husky-faculty.app.collegiatemobile.com/prepaid?planOfferingId=poff_5JOGPAOXZ0TAJ8V3';
          case 11 : return 'https://husky-faculty.app.collegiatemobile.com/prepaid?planOfferingId=poff_64EJZDNVTWHUWKOT';
          default: return '';
        }
      case 2: 
        switch (planId) {
          case 4 : return 'https://bears-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_1D7CIQCAJ05J8ZI8'
          case 5 : return 'https://bears-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_RO5U1GO68WTUPQU8';
          case 6 : return 'https://bears-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_HNPWEFX1N20NT072';
          case 11 : return 'https://bears-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_AI84YJ27VK9S5J2W';
          default: return '';
        }
      case 3: 
        switch (planId) {
          case 4 : return 'https://beavs-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_D0IUZ087FDR1PEZX'
          case 5 : return 'https://beavs-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_5UVQXM6RLYAL8LYG';
          case 6 : return 'https://beavs-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_U11TTYP8BEJTRWZZ';
          case 11 : return 'https://beavs-faculty.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_MH008IWNCTVF66TA';
          default: return '';
        }
      default: return '';

    }
  }
 
	tenantName: string
	customerType: string = 'Faculty';
	tenant: TenantService;
 
 
  loadeddata: any;
    @ViewChild('carousel', { static: false }) carouselRef!: ElementRef;
   activeIndex = 0;
    scrollToCard(index: number) {
    const carousel = this.carouselRef.nativeElement as HTMLElement;
    const cardWidth = carousel.children[0].clientWidth + 16; // 16 = spacing
    carousel.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
    this.activeIndex = index;
  }
   getDotClass(i: number) {
    return {
      'w-3 h-3 rounded-full': true,
      'bg-purple-500': this.activeIndex === i,
      'bg-gray-300': this.activeIndex !== i
    };
  }

  constructor(private router: Router,private settingsService: PageviewsettingsService,private route: ActivatedRoute, private tenantService: TenantService) {
	this.tenant = tenantService;
    this.tenantName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';
   
    this.settingsService.getCollegetenantcode(this.tenantName).subscribe(data => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings();
		});
  }
ngAfterViewInit() {
    const carousel = this.carouselRef.nativeElement as HTMLElement;
  

    // Listen to scroll events
    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const cardWidth = carousel.children[0].clientWidth + 16; // 16px gap (space-x-4)
      const index = Math.round(scrollLeft / cardWidth);
      this.activeIndex = index;
    });
    
  }
  ngOnInit() {
 
    let collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';

    
   
       this.settingsService.getCollegetenantcode(collegeName).subscribe(data => {
       this.tenantId = data.id
       this.affiliateId=data.affiliateId
      
       this.settingsService.background$.subscribe(bg => this.images.background = bg);
      
    });
   
  } 

 

  data: planData[] = ['30GB', '15GB', '10GB', '5GB'];
  selectedData: number | null = null;

 
  highlightFirstBold(text: string): string {
  const index = text.indexOf(' ');
  if (index === -1) return `<strong>${text}</strong>`;
  return `<strong>${text.slice(0, index)}</strong>${text.slice(index)}`;
}
  
 

  toggleCards() {
    this.showCards = !this.showCards;
    this.fetchBroadbandFactLabels()
  }
  updatePageContent() {

    const customer = this.customerType || 'student';
  if (!this.plansdata?.planDetails || this.plansdata.planDetails.length === 0) return;
const titleMap: Record<string, string> = {
  student: this.loadeddata.studentmainsectiontitle	,
  // faculty: 'Choose Your Student Plan',
  alumni: this.loadeddata.alumnimainsectiontitle
};

const subtitleMap: Record<string, string> = {
  student: this.loadeddata.studentmainsectionsubtitle,
  faculty: 'Flexible plans for academic professionals',
  alumni: this.loadeddata.alumnimainsectionsubtitle
};
  const plans = this.plansdata.planDetails.map((plan: any, index: number) => {
   
    return {
      id: plan.mobilePlanId,
      plancode: plan.planCode,
      name: plan.name,
      price: plan.consumerPrice/100,
      talk: plan.cardDetails?.[1]?.text ?? '',
      text: plan.cardDetails?.[2]?.text ?? '',
      data:plan.cardDetails?.[0]?.text ?? '',
      wifi: plan.cardDetails?.[3]?.text ?? '',
      mobiledata: plan.cardDetails?.[4]?.text ?? '',
      vedio: plan.cardDetails?.[5]?.text ?? '',
      offer: plan.cardDetails?.[6]?.text ?? '',
      contract: plan.cardDetails?.[7]?.text ?? '',
      internationationaltexts: index === 2 && plan.cardDetails?.[7]?.text ? '✔ ' + plan.cardDetails?.[7]?.text : '',
      internationationaldata: index === 2 && plan.cardDetails?.[8]?.text ? '✔ ' + plan.cardDetails?.[8]?.text : '',
      buttonname: ['Get Basic', 'Get Standard', 'Get Premium'][index] ?? 'Get Plan',
      
    };
  });



  const sharedSettings = {
    backgroundimage: this.loadeddata?.backgroundimage ?? '',
    choosesectionbgcolor: this.loadeddata?.choosesectionbgcolor ?? '',
    fontsize: this.loadeddata?.fontsize ?? '',
   title: titleMap[customer],            // override here
  subtitle: subtitleMap[customer],
    plans,
    whyHusky: [
      { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et.' },
      { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et' },
      { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et' },
      { backgroundcolor: '#4b2e83' }
    ]
  };

  this.pageSettings = sharedSettings;
  this.plans = plans;


}

  selectData(dataKey:any,): void {
  // this.selectedData = dataKey;
this.selectedData = this.selectedData === dataKey ? null : dataKey;
  console.log(this.selectedData)
  

   this.fetchBroadbandFactLabel(this.selectedData)
}

 fetchBroadbandFactLabel(planId: any) {
  this.settingsService.getbroadbandplans(planId).subscribe((labelData) => {
    this.broadbandLabelData = labelData.result;
  
  });
}
//  for backup: if toggling is needed
fetchBroadbandFactLabels() {
  const planIds = [6, 11, 4, 5]; // Replace with your actual plan IDs
  const requests = planIds.map(id => this.settingsService.getbroadbandplans(id));

  forkJoin(requests).subscribe(results => {
    this.broadbanddata= results.map(res => res.result);
    console.log(this.broadbandLabelData);
  });
}
  

  loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			const color = this.loadeddata?.PrimaryColor;
	
			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
      });

      this.plans= [
        {
          id: 6,
          url: this.getPlanUrl(6),
          name: 'Faculty Unlimited',
          data:'30GB',
          price: 45,
          discountedPrice: 36,
          description: 'Taxes & Fees Included',
          subText: 'For on-the-go faculty, and frequent travelers.',
          highlight: true,
          features: [
            { title: '<b>Unlimited Data</b><br>(reduced speeds after 30GB)*' },
            { title: '<b>Up to 15GB Hotspot Data Included</b>' },
            { title: '<b>5GB International Data Roaming*</b>'},
            { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
            { title: 'VIP Perks and Experiences'},
            { title: 'Unlimited Talk & Text' },
            { title: 'Wi-Fi Calling'},

          ]
        },
        {
          id: 11,
          url: this.getPlanUrl(11),
          name: 'Faculty Premium',
          data:'15GB',
          price: 35,
          discountedPrice: 28,
          description: 'Taxes & Fees Included',
          subText: 'Ideal for faculty and staff, looking for a powerful plan with purpose.',
          highlight: false,
          features: [
            { title: '<b>Unlimited Data</b><br>(reduced speeds after 15GB)*' },
            { title: '<b>Up to 15GB Hotspot Data Included</b>' },
            { title: '<b>3GB International Data Roaming*</b>'},
            { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
            { title: 'VIP Perks and Experiences' },
            { title: 'Unlimited Talk & Text' },
            { title: 'Wi-Fi Calling' },
          ]
        },
        {
          id: 4,
          url: this.getPlanUrl(4),
          name: 'Faculty Plus',
          data:'10GB',
          price: 25,
          discountedPrice: 20,
          description: 'Taxes & Fees Included',
          subText: 'The perfect balance of your data and value needs.',
          highlight: false,
          features: [
            { title: '<b>Unlimited Data</b><br>(reduced speeds after 10GB)*'},
            { title: '<b>Up to 10GB Hotspot Data Included</b>' },
            { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
            { title: 'VIP Perks and Experiences' },
            { title: 'Unlimited Talk & Text' },
            { title: 'Wi-Fi Calling' },
          ]
        },
        {
          id: 5,
          url: this.getPlanUrl(5),
          name: 'Faculty Basic',
          data:'5GB',
          price: 20,
          discountedPrice: 16,
          description: 'Taxes & Fees Included',
          subText: 'Great value for everyday use.',
          highlight: false,
          features: [
            { title: '<b>5GB High-Speed Data</b>'},
            { title: '<b>Up to 5GB Hotspot Data Included</b>' },
            { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
            { title: 'VIP Perks and Experiences' },
            { title: 'Unlimited Talk & Text' },
            { title: 'Wi-Fi Calling' },
          ]
        }

      ];
  }


  selectPlan(plancode: any,value:any) {

if(value =='cardhighlighted'){
     this.selectedPlanName = plancode; 
    console.log(plancode)
    analytics.track(plancode)
     
}
   
    // const url = `https://husky-student.collegiatemobile.com/prepaid/create-your-account?planId=${planId}&type=${this.customerType}`;
 if( value =='buttonclicked')
  {
    const url = `${plancode}`
     window.location.href = url;  
   
}

  
    // this.router.navigateByUrl(['https://husky-student.collegiatemobile.com/prepaid/create-your-account'], { queryParams: { planId, type: this.customerType } });
  }
   trackevent(event:any){
    analytics.track(event)
  }
}
